import { ViewModel } from "binder";
import { InvoicesListViewModel } from "../invoicesList/invoicesList-viewModel";

export class InvoiceForCashViewModel extends InvoicesListViewModel{
    public getTitle() {
        return 'صندوق';
    }
    getPageSize(){
        return 50;
    }

    constructor(parentViewModel: ViewModel) {
        super(parentViewModel)
        this.showSum = true;
    }
    protected override getServiceAddress():string{
        return '/Complex/SellServices/GetAllUnpaidInvoices';
    }
    protected override updateFilteringInformation(filteringInformation: any){
        if(filteringInformation.OrderInfo.length == 0)
        {
            let sort = {
                fieldName:'createdTime',
                order:'DESC',
                type:'date'
            };
            filteringInformation.OrderInfo = [sort];
        }
        let filterString = filteringInformation.Filters.FilterString;
        if(filterString=='')
            filterString = '[]'
        let filter = JSON.parse(filterString);
        
        filteringInformation.Filters.FilterString = JSON.stringify(filter);
        return filteringInformation;
    } 
}
